export default __webpack_public_path__ + "static/media/holding.94ef51c7.svg";